export default "__VITE_ASSET__Hv5SjyK2__"